import axios from 'axios'

export default class ApiManager {
    /**
     * Get series of customer
     */
    static async getSeries(userId) {
        return axios.get(`/back-office/series_customers/${userId}/getAllAvailableSeries`).then((res) => {
            return res.data
        })
    }

    /**
     * Get treatments of customer
     */
    static async getTreatments(userId) {
        return axios.get(`/back-office/treatments_customers/${userId}/getAllAvailableTreatments`).then((res) => {
            return res.data
        })
    }

    static async getPromoCode(codeId, fromBackend = true) {
        return axios.get(`/back-office/promotion/get/code/${codeId}`, { params: { fromBackend } }).then((res) => {
            return res.data
        })
    }

    static async getItemPromoCode(codeId, fromBackend = true) {
        return axios.get(`/back-office/promotion/get/item-card/code/${codeId}`).then((res) => {
            return res.data
        })
    }

    static async editSeller(rowId, sellerId, adviserId) {
        return axios
            .post(`/back-office/caisse/edit/seller/${rowId}`, { type: 'staff', seller_id: sellerId, advised_id: adviserId })
            .then((res) => {
                return res.data
            })
    }

    static async getAllStaffs() {
        return axios.get(`/back-office/caisse/getAllStaffs`).then((res) => {
            return res.data
        })
    }

    static async getItemCategory(itemId, type) {
        return axios.post(`/back-office/caisse/getItemCategory/${itemId}`, { type: type })
    }

    // static async applyPromotionToCart(rowId, discountAmount, discountType) {
    //     return axios.post(`/back-office/promotion/apply/cart/${rowId}`, {discountAmount: discountAmount, discountType: discountType})
    // }

    static async getAllQuotesTemplates() {
        return axios.get('/back-office/etablissement/quotes-templates').then((res) => {
            return res.data
        })
    }
    static async saveQuoteTemplate(orderId, templateId) {
        return axios
            .post(`/back-office/devis/order/update-quote-template`, {
                templateId: templateId,
                orderId: orderId,
            })
            .then((res) => {
                return res.data
            })
    }

    static async getQuote(orderId, params) {
        return axios.get(`/back-office/devis/${orderId}/get-quote`, { params: params }).then((res) => {
            return res.data
        })
    }
    static async sentQuote(orderId) {
        return axios.get(`/back-office/devis/${orderId}/sent-quote`).then((res) => {
            return res.data
        })
    }

    /**
     * Récupère le token du Docuseal Builder pour un PDF donné.
     * @param {Object} payload
     * @param {string} payload.document_url
     * @param {string|number} payload.order_id
     * @returns {Promise<{data:{token:string}}>}
     */
    static async getDocusealBuilderToken(payload) {
        return axios.post('/back-office/devis/docuseal/builder_token', payload)
    }

    /**
     * Récupère un JWT HS256 pour initialiser le Form Builder DocuSeal
     * @param {Object} payload
     *   - template_id: number (id du template existant)
     *   - order_id: string|number (id du devis concerné)
     */
    static async getDocuSealBuilderToken(payload) {
        return axios.post('/back-office/devis/docuseal/builder_token', payload)
    }

    /**
     * Crée une "submission" DocuSeal pour un client (formulaire de signature)
     * @param {Object} payload
     *   - template_id: number
     *   - email: string
     *   - order_id: string|number
     *   - send_email: boolean
     */
    // static async createDocuSealSubmission(payload) {
    //     return axios.post('/api/docuseal/submission', payload)
    // }

    static async updateDueDate(orderId, dueDate) {
        return axios.post(`/back-office/devis/${orderId}/due-date`, { due_date: dueDate })
    }

    static async validateQuote(orderId) {
        return axios.post(`/back-office/devis/${orderId}/validate-api`)
    }

    static async upsertDocuSealTemplate(payload) {
        return axios.post('/back-office/devis/docuseal/templates/upsert', payload)
    }

    static async getDocuSealBuilderTokenByTemplateId(templateId) {
        return axios.get(`/back-office/devis/docuseal/templates/${templateId}/builder-token`)
    }
}
